import { levelAt } from "./check";
import { HOME_KIND_OF_COMPANY_TYPE } from "./homeKind";
import { reaches } from "./levels";
import { isBelow, samePlace } from "./places";
import { RESOURCE_PATHS } from "./resources";
export function homeKindOfChoice(home, directory) {
    var _a;
    if (home.kind === "nenda")
        return "nenda";
    const type = (_a = directory.companies.find((c) => c.id === home.companyId)) === null || _a === void 0 ? void 0 : _a.type;
    return type &&
        Object.prototype.hasOwnProperty.call(HOME_KIND_OF_COMPANY_TYPE, type)
        ? HOME_KIND_OF_COMPANY_TYPE[type]
        : "customer";
}
export function homePlace(home, directory) {
    return {
        kind: "company",
        id: home.kind === "nenda" ? directory.nendaCompanyId : home.companyId,
    };
}
export function isInsideHome(place, home, directory, tree) {
    if (home.kind === "nenda")
        return true;
    const top = homePlace(home, directory);
    return samePlace(place, top) || isBelow(place, top, tree);
}
export function beyondCaller(caller, target, grants, tree) {
    const found = [];
    for (const grant of grants) {
        const managesUsers = levelAt(caller, "users", grant.place, tree) === "administrate";
        for (const resource of RESOURCE_PATHS) {
            if (resource === "patient-data" && managesUsers)
                continue;
            const level = levelAt(target, resource, grant.place, tree);
            if (level === "none")
                continue;
            const held = levelAt(caller, resource, grant.place, tree);
            if (!reaches(held, level)) {
                found.push({ place: grant.place, resource, level, held });
            }
        }
    }
    return found;
}
export function grantProblemHint(problem) {
    switch (problem.code) {
        case "role_above_limit":
            return `The role ${problem.role} goes above ${problem.limit}, the most this user's home organisation allows. Only Nenda's own users get administrate.`;
        case "level_above_limit":
            return `${problem.level} on ${problem.resource} is above ${problem.limit}, the most this user's home organisation allows. Only Nenda's own users get administrate.`;
        case "unknown_role":
            return `There is no role called ${problem.role}.`;
        case "unknown_resource":
            return `There is no resource called ${problem.resource}.`;
        case "unknown_level":
            return `${problem.level} is not a level.`;
        case "repeated_resource":
            return `${problem.resource} is set twice on one grant.`;
    }
}
export function ownerHomeProblem(home, kind, grants) {
    if (kind !== "content-owner" || (home === null || home === void 0 ? void 0 : home.kind) !== "company")
        return null;
    for (const g of grants) {
        if (g.place.kind !== "company" || g.place.id !== home.companyId) {
            return "outside_owner_company";
        }
        if (g.role !== null && g.role !== "content-owner") {
            return "role_not_for_content_owner";
        }
    }
    return null;
}
